import { Table } from '@flos/react-ui';
import { useHippoText } from '../../../../hooks/useHippoText';
import CoverableDetailsTemplate from '../../../../templates/CoverableDetailsTemplate';
import WizardPagetemplate from '../../../../templates/WizardPagetemplate';
import { allCoverablesOnsaAtom } from '../../../../recoil/atoms/allCoverablesOnsaAtom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { getOnsaCurrentProductSelector } from '../../../../recoil/selectors/getOnsaCurrentProductSelector';
import { getPRCInsuranceSumsConfig } from './InsuranceSumsPRCConfig';
import type { RowInformation } from '../../../../config/flavourConfig';
import TableRow from '../../../../shared_components/TableRow/TableRow';
import { useState } from 'react';
import CallMeModal from '../../../../shared_components/CallMeModal/CallMeModal';
import HelpLink from '../../../../shared_components/HelpLink/HelpLink';
const InsuranceSumsPRCStep = ({
    goNext,
    goPrevious
}: {
    goNext: () => void;
    goPrevious: () => void;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const [coverables] = useRecoilState(allCoverablesOnsaAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const prcCoverable = coverables.privateContent ?? [];
    const coverableIndex = prcCoverable?.findIndex(
        (coverable) => coverable.fixedId === currentProduct.fixedId
    );
    const currentCoverable = prcCoverable[coverableIndex];
    const [showCallMeModal, setShowCallMeModal] = useState<boolean>(false);
    const componentProperties = getPRCInsuranceSumsConfig(currentCoverable, getHippoText);
    const coverableRows = componentProperties.rowsInformation;

    return (
        <WizardPagetemplate onNext={goNext} onPrevious={goPrevious}>
            <CoverableDetailsTemplate
                header={getHippoText('DSS-COVERABLE-INFORMATION-STEP-SUMS-HEADER')}
            >
                <Table mobileDirection="vertical" className="u-spacing-stack-sm">
                    <Table.Body>
                        {coverableRows.map((rowInfo: RowInformation) => {
                            return (
                                <TableRow
                                    key={rowInfo.key ?? rowInfo.name}
                                    rowInfo={rowInfo}
                                    shouldAlignTextLeftOnMobile
                                />
                            );
                        })}
                    </Table.Body>
                </Table>
            </CoverableDetailsTemplate>
            <HelpLink
                onClick={() => {
                    setShowCallMeModal(true);
                }}
            >
                {getHippoText('DSS-COVERABLE-INFORMATION-STEP-SUMS-INSURANCE-SUMS-TOO-LOW')}
            </HelpLink>
            {showCallMeModal && (
                <CallMeModal
                    activityCode="dss_call_request"
                    showModal={showCallMeModal}
                    closeModal={() => {
                        setShowCallMeModal(false);
                    }}
                    title={getHippoText('DSS-CALLME-MODAL-INSURANCESUMS-PRC-HEADER')}
                    description={getHippoText('DSS-CALLME-MODAL-INSURANCESUMS-PRC-BODY')}
                />
            )}
        </WizardPagetemplate>
    );
};

export default InsuranceSumsPRCStep;
